<template>
  <form id="flashdeal-privilege-campaign-list" @submit.prevent="onSubmitForm">
    <campaign-information :formData="form" />
    <campaign-entry-list
      :isEdit="isEdit"
      :onOpenAddPrivilege="onOpenAddPrivilege"
      ref="campaignEntryList"
    />

    <!--  -->
    <add-privilege-modal
      v-if="modalType.addPrivilege"
      @onEdit="openEditModal"
      @onCloseModal="onCloseAddPrivilege"
    />

    <!--  -->
    <div class="flashdeal-privilege-btn-wrp">
      <div class="privilege-btn-wrp mt-2 mb-2">
        <div class="d-flex justify-content-center">
          <cancel-button
            class="mr-1"
            @click.native="$router.push('/flashdeal/privilege/campaign/list')"
          />
          <save-button :type="'submit'" class="ml-1" />
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import AddPrivilegeModal from "./modal/AddPrivilegeModal.vue";
import userPrivilegeCampaignInfo from "./hooks/userPrivilegeCampaignInfo";
import CampaignInformation from "./components/CampaignInformation.vue";
import CampaignEntryList from "./components/CampaignEntryList.vue";

export default {
  components: {
    AddPrivilegeModal,
    CampaignInformation,
    CampaignEntryList,
  },

  setup() {
    const {
      form,
      modalType,
      isEdit,
      onOpenAddPrivilege,
      onCloseAddPrivilege,
      openEditModal,
      closeEditModal,
      onSubmitForm,
    } = userPrivilegeCampaignInfo();

    return {
      form,
      modalType,
      isEdit,
      onOpenAddPrivilege,
      onCloseAddPrivilege,
      openEditModal,
      closeEditModal,
      onSubmitForm,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style scoped>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/v-select.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/status.css";
@import "~@/assets/css/pages/data-management.css";
</style>
